(function () {

    angular
        .module('smartertoolsApp')
        .filter('friendlyFromNow', friendlyFromNow);

    function friendlyFromNow() {
        return function (date) {
            if (date === 'N/A' || date === null)
                return 'N/A';
            else if (date >= 0)
                return date;
            else
                return 'Exp ' + moment(new Date()).add(date, 'days').fromNow();
        }
    }

})();